import absoluteUrl from "next-absolute-url";
import {getAxiosInstance} from "src/server/utils/getAxiosInstance";
import * as ProductsApi from "src/core/api/products";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import {findRelation} from "src/core/api/utils";
import get from "lodash/get";
import {generateSiteMap} from "src/server/sitemaps";
import {getSiteInCluster} from "src/server/clusters";
import {ALL_PRODUCTS_DELIVERY_TYPE} from "src/server/constants";

const ProductsSitemap = () => {};

export const getServerSideProps = async ({res, req, query}) => {
  const {host} = absoluteUrl(req);
  const shop = query.shop;
  const axiosInstance = getAxiosInstance(shop, host);
  try {
    const data = await getAllProductPaths(axiosInstance);
    const siteConfig = getSiteInCluster(host);
    const sitemap = await generateSiteMap({
      shop,
      host: siteConfig.canonicalDomain,
      data,
      siteMapName: "products",
    });
    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (e) {
    console.error(e);
  }
  return {
    props: {},
  };
};

const LIMIT = 100;
async function getAllProductPaths(axiosInstance) {
  const initialParams = pickBy(
    {limit: LIMIT, offset: 0, delivery_type: ALL_PRODUCTS_DELIVERY_TYPE},
    identity
  );

  const initialResponse = await ProductsApi.list(initialParams, {}, axiosInstance);

  const meta = initialResponse.meta;
  let included = initialResponse.included;
  let products = initialResponse.data;

  const nRequests = Math.ceil(meta.total_count / LIMIT) - 1;

  const responses = await requestProducts(
    axiosInstance,
    `/api/v1/products/`,
    nRequests,
    LIMIT
  );

  responses.forEach(response => {
    response.data.map(product => products.push(product));
    response.included.map(include => included.push(include));
  });

  return products.map(product => {
    const productSlug = get(product, "attributes.slug", "");
    const productPath = productSlug ? `${productSlug}/` : "";
    const category = findRelation(
      included,
      get(product.relationships.category, "data", {})
    );
    const categorySlug = get(category, "attributes.slug", "");
    const categoryPath = categorySlug ? `${categorySlug}/` : "";
    const brand = findRelation(included, get(product.relationships.brand, "data", {}));
    const brandSlug = get(brand, "attributes.slug", "");
    const brandPath = brandSlug ? `${brandSlug}/` : "";
    return {path: "/products/" + brandPath + categoryPath + productPath};
  });
}
async function requestProducts(axios, endpoint, nRequests, limit) {
  let productList = [];
  let promises = [];

  for (let i = 0; i < nRequests; i++) {
    let params = pickBy(
      {
        limit: limit,
        offset: i * limit + limit,
        delivery_type: ALL_PRODUCTS_DELIVERY_TYPE,
      },
      identity
    );
    promises.push(
      axios.get(endpoint, {
        params,
        headers: axios.defaults.headers.common,
      })
    );
  }

  return Promise.all(promises)
    .then(responses => {
      responses.forEach(response => {
        productList.push(response.data);
      });
      return productList;
    })
    .catch(e => {
      console.error(e);
    });
}

export default ProductsSitemap;
